// What each email is (set by the app when it reads the email)
export const EMAIL_TYPES = {
  bank_alert: { label: 'Bank alert', color: 'primary' },
  upi_receipt: { label: 'UPI payment', color: 'primary' },
  merchant_receipt: { label: 'Receipt', color: 'secondary' },
  card_statement: { label: 'Card statement', color: 'warning' },
  account_statement: { label: 'Bank statement', color: 'default' },
  bill_due: { label: 'Bill due', color: 'warning' },
  payment_confirmation: { label: 'Bill paid', color: 'success' },
  refund: { label: 'Refund', color: 'success' },
  investment_confirmation: { label: 'Investment', color: 'info' },
  not_financial: { label: 'Not financial', color: 'default' },
};

export const emailTypeLabel = (type) => EMAIL_TYPES[type]?.label || type;

// Filters for the forwarded emails list
export const EMAIL_TYPE_FILTERS = [
  { value: '', label: 'All emails' },
  { value: 'bank_alert,upi_receipt,refund,investment_confirmation', label: 'Transactions' },
  { value: 'card_statement,bill_due,payment_confirmation', label: 'Bills & card statements' },
  { value: 'merchant_receipt', label: 'Receipts' },
  { value: 'account_statement', label: 'Bank statements' },
  { value: 'not_financial', label: 'Not financial' },
];

// Receipts are documents: they are matched to a transaction, never saved as one on their own
export const RECEIPT_STATUS = {
  unmatched: { label: 'Looking for its payment', color: 'default' },
  matched: { label: 'Matched', color: 'success' },
  needs_decision: { label: 'No payment found', color: 'warning' },
  added: { label: 'Added as transaction', color: 'success' },
  dismissed: { label: 'Dismissed', color: 'default' },
};

// Kinds of transaction: what the money did. Only "Spending" counts as spending.
export const TRANSACTION_KINDS = [
  { value: 'expense', label: 'Spending' },
  { value: 'income', label: 'Income' },
  { value: 'transfer', label: 'Transfer' },
  { value: 'investment', label: 'Investment' },
  { value: 'refund', label: 'Refund' },
  { value: 'asset', label: 'Big purchase' },
];

export const kindLabel = (kind) => TRANSACTION_KINDS.find(k => k.value === kind)?.label || kind || '—';

// One line on what each kind means (tooltips)
const KIND_HELP = {
  expense: 'Spending: counts towards your spending and budgets.',
  income: 'Income: money you earned.',
  transfer: 'Transfer: money moved between your own accounts, such as a card bill payment. Not counted as spending.',
  investment: 'Investment: money saved or invested. Not counted as spending.',
  refund: 'Refund: money back for something you bought. Not counted as income.',
  asset: 'Big purchase: a home or car, kept out of monthly spending.',
};
export const kindHelp = (kind) => KIND_HELP[kind] || '';

// Kinds that make sense for money going out / coming in
export const kindsFor = (type) => TRANSACTION_KINDS.filter(k =>
  type === 'credit' ? k.value !== 'expense' : k.value !== 'income');
